import usePortfolio from "../../hooks/PortfolioProvider"
import {Chart} from "react-google-charts"
import PortUtils from "../../portlibs/PortUtils"
import { usePath } from "../../libs/path/PathProvider"
import Summarize from "../../models/Summarize"
import Utils from "../../libs/Utils"
import useDateRangeFilter from "../../portlibs/DateRangeFilterProvider"
import { ForwardedRef, forwardRef, useImperativeHandle } from "react"

export interface IAssetChart {
    export:Function
}
export default forwardRef(({}, ref?:ForwardedRef<IAssetChart>) => {
    const {query} = usePath()
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const {end} = useDateRangeFilter()
    let holdings = portfolio.filter(currency, filter, account, false)
    if (!filter || filter?.toUpperCase()=="CASH") holdings.push(portfolio.cash(0, account), portfolio.cash(1, account))
    if (!PortUtils.dateEq(end, new Date())) holdings = PortUtils.trimHoldings(holdings, end.getTime())

    useImperativeHandle(ref, () => ({
        export() {Utils.exportFile(new Blob([Summarize.data(holdings, end, true).join("\n")], {type:"text/csv;charset=utf-8"}), `Home ${Utils.formatDate("yyyy-MM-dd", new Date())}.csv`)}
    }), [holdings])

    const data = Summarize.graph(holdings, end)
    data.unshift(["Date", "Asset"])
    const options = {
        title:"Asset",
        legend: {position:"none"},
        curveType: "function"
    }
    return <Chart className="chart" chartType="Line" height="400px" width="100%" data={data} options={options}/>
})